module.exports = __webpack_public_path__ + "static/WillDendyInSuit-e8142c75985ce9a4970458f6ddb8e133.jpeg";